import(/* webpackMode: "eager" */ "/home/runner/work/geounique/geounique/node_modules/next/dist/client/link.js");
